<template>
  <EditItemForm :con="con" :editedItem="editedItem" @closed="close">
    <template>
      <v-container>
        <v-row>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.id")
              }}</span>
              {{ editedItem.id }}
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("ImportDetails.trStart")
              }}</span>
              <span>{{
                new Date(editedItem.dateStart).toLocaleString("fr-FR")
              }}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.dateEnd")
              }}</span>
              <span>{{
                new Date(editedItem.dateEnd).toLocaleString("fr-FR")
              }}</span>
            </v-card-text>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.User")
              }}</span>
              <span
                >{{ editedItem.user.firstName }}
                {{ editedItem.user.lastName }}</span
              >
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.StatuUser")
              }}</span>
              <span v-for="type in editedItem.user.types">{{ type }}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.UserCompany")
              }}</span>
              <span>popo{{ editedItem.user.company }}</span>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.Center")
              }}</span>
              <span>{{ editedItem.center.name }}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.Room")
              }}</span>
              <span>{{ editedItem.center.address }}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.reason")
              }}</span>
              <span>{{ editedItem.reason }}</span>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="font-weight-medium">{{
              $t("BookingDetails.Complement")
            }}</span>
            <br />
            <pre style="white-space: pre-wrap">
      {{
                editedItem.complement
                  ? editedItem.complement
                  : $t("BookingDetails.ComplementNoComment")
              }}
    </pre
            >
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EditItemForm>
</template>

<script>
import EditItemForm from "../EditItemForm";
export default {
  name: "DetailBookingDialog",
  components: {
    EditItemForm,
  },
};
</script>

<style></style>
